import reducer, { selectors, types } from "./ducks"
import Loadable from "base_components/Loadable"
import * as actions from "./thunks"
const pages = {
  Tickets: Loadable({
    loader: () => import("./TicketsPage")
  })
}
export { pages, selectors, types, reducer, actions }
